import { render, staticRenderFns } from "./ReceiverOrgItemEditPage.vue?vue&type=template&id=27b062ca&"
import script from "./ReceiverOrgItemEditPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrgItemEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverOrgItemEditPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports